import { getStateColor, getStateTranslationKey } from "@msuite/utils/strings";
import type { Enums, Nullable } from "@msuite/utils/types";
import { useTranslation } from "../localization";
import { Tag, type TagProps } from "./tag";

/** Props Interface */
interface StateTagProps {
	state: Nullable<Enums<"state">>;
	size?: TagProps["size"];
}

export function StateTag({ state, size }: StateTagProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Guard */
	if (!state) return null;

	/** Render */
	return (
		<Tag
			color={getStateColor(state)}
			variant="plain"
			size={size}
		>
			{t(getStateTranslationKey(state))}
		</Tag>
	);
}
